import { IDBPDatabase } from 'idb'
import { IDBSchema } from '../types'

/**
 * CHANGES:
 *
 * - Created `models` table
 * - Created `fields` table
 * - Created `enums` table
 */

export default (
  database: IDBPDatabase<IDBSchema>,
  transaction: IDBTransaction,
  next: () => void
) => {
  STUDIO_ENV_DEVELOPMENT && console.log('---Running migration for v2---')

  database.createObjectStore('models', { keyPath: 'id' })
  STUDIO_ENV_DEVELOPMENT && console.log('Created models table')

  database.createObjectStore('fields', { keyPath: 'id' })
  STUDIO_ENV_DEVELOPMENT && console.log('Created fields table')

  database.createObjectStore('enums', { keyPath: 'id' })
  STUDIO_ENV_DEVELOPMENT && console.log('Created enums table')

  STUDIO_ENV_DEVELOPMENT && console.log('---Migrated to v2---')
  return next()
}
